import React from 'react';
import styled, { css } from 'styled-components';
import {
    bodyCustomStyles,
    ParagraphWrapper,
    titleCustomStyles,
} from './ContainerQueryStyles';
import { DATA_GRABS } from './steps/common/constans';

/**
 * Off-screen anchors carrying the booker's current design tokens, one per `data-grab` the editor's design
 * panel reads them through. The panel previews and resets colors and text styles against these, so they have
 * to render for every booker - native and cal atoms alike - which is why they no longer sit inside the
 * container-query styles that only the cal-atoms path renders.
 */
const HiddenStylesHelper = () => {
    return (
        <>
            <HiddenPrimaryAnchor
                aria-hidden='true'
                data-grab={DATA_GRABS.bookerPrimaryColor}
            />
            <HiddenSecondaryAnchor
                aria-hidden='true'
                data-grab={DATA_GRABS.bookerSecondaryColor}
            />
            <HiddenBackgroundAnchor
                aria-hidden='true'
                data-grab={DATA_GRABS.bookerBackgroundColor}
            />
            <HiddenHeadingAnchor
                aria-hidden='true'
                data-grab={DATA_GRABS.bookerTitle}
            />
            <HiddenParagraphStyles aria-hidden='true'>
                <p data-grab={DATA_GRABS.bookerSubtitle} />
            </HiddenParagraphStyles>
            <HiddenBodyAnchor
                aria-hidden='true'
                data-grab={DATA_GRABS.bookerBody}
            />
        </>
    );
};

const hiddenElementStyles = css`
    position: absolute;
    left: -9999px;
    width: 1px;
    height: 1px;
    overflow: hidden;
    pointer-events: none;
`;

const HiddenElementStyles = styled.div`
    ${hiddenElementStyles}
`;

const HiddenElementH5Styles = styled.h5`
    ${hiddenElementStyles}
`;

const HiddenParagraphStyles = styled(ParagraphWrapper)`
    ${hiddenElementStyles}
`;

const HiddenPrimaryAnchor = styled(HiddenElementStyles)`
    color: ${({ theme }) => theme.bookerPrimaryColor};
`;

const HiddenSecondaryAnchor = styled(HiddenElementStyles)`
    background-color: ${({ theme }) => theme.bookerSecondaryColor};
`;

const HiddenBackgroundAnchor = styled(HiddenElementStyles)`
    background-color: ${({ theme }) => theme.bookerBackgroundColor};
`;

const HiddenHeadingAnchor = styled(HiddenElementH5Styles)`
    ${titleCustomStyles}
`;

const HiddenBodyAnchor = styled(HiddenElementStyles)`
    ${bodyCustomStyles}
`;

export default HiddenStylesHelper;
